import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconOldPhone: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-filled-radius-2-stroke-1.5-IconOldPhone"><Path fillRule="evenodd" clipRule="evenodd" d="M4.75 1C5.16421 1 5.5 1.33579 5.5 1.75V3.29985C5.87503 3.10814 6.29989 3 6.75 3H17.25C18.7688 3 20 4.23122 20 5.75V17.25C20 19.8734 17.8734 22 15.25 22H8.75C6.12665 22 4 19.8734 4 17.25V1.75C4 1.33579 4.33579 1 4.75 1ZM8.75 7C8.33579 7 8 7.33579 8 7.75V13.25C8 13.6642 8.33579 14 8.75 14H15.25C15.6642 14 16 13.6642 16 13.25V7.75C16 7.33579 15.6642 7 15.25 7H8.75Z" fill="currentColor"/></CentralIconBase>;
});

export default IconOldPhone;
